<template>
  <div
    class="owal-input-text__container"
    :class="{ padded: isPadded }"
  >
    <label
      v-if="label"
      class="owal form field label"
    >
      {{ label }}
    </label>
    <input
      class="owal text input"
      :class="{ padded: isPadded }"
      :value="value"
      :type="type"
      :required="required"
      :placeholder="placeholder"
      :name="name"
      @input="setValue($event.target.value)"
      @blur="emitBlur()"
    >
  </div>
</template>

<script>
import { Input } from './mixins'

export default {
  name: 'FormFieldInputText',
  mixins: [Input],
  props: {
    tokenizers: {
      type: Array,
      required: false,
      default: function () {
        return []
      },
    },
    isPadded: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      value: this.initialValue,
    }
  },
  created () {
    this.applyInitialValue()
  },
}
</script>

<style scoped>
.owal-form-input__container {
  font-family: 'Lato-Italic';
  font-size: 1rem;
  color: #8492A6;
  letter-spacing: 0;
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
}

.owal-form-input__container input {
  background: #F0F0F0;
  border: 2px solid #E0E0E0;
  border-radius: 5px;

  font-family: 'Lato-Regular', sans-serif;
  font-size: 1.28571rem;
  color: #324057;
  letter-spacing: 0;
  padding: 0.87571rem 0.64285rem;
  margin: 0.2857142857rem .1785714286rem;
  height: 3.6rem;
  flex-grow: 1;
  text-align: center;
}

.owal {
  font-family: 'Lato', 'Avenir';
}

.owal.form.inline.field {
  display: inline-flex;
  flex-direction: column;
  padding: 0.3975rem;
  margin: 0.3975rem;
  box-sizing:border-box;
}

.owal.form.field.label {
  margin-left: 1rem;
  margin-bottom: 0.53rem;
  font-weight: normal;
  font-size: 14px;
  color: #475669;
  letter-spacing: 0;
}

.owal.form.inline.field .owal.text.input {
  width: 25rem;
}

.owal-input-text__container {
  display: flex;
  flex-direction: column;
  box-sizing:border-box;
}

.owal-input-text__container.padded input {
  padding: 0.3975rem;
  margin: 0.3975rem;
}

.owal.text.input {
  font-weight: normal;
  font-size: 14px;
  color: #475669;
  letter-spacing: 0;
  border: 1px solid rgba(34,36,38,.15);
  border-radius: 0.35rem;
}

.owal.text.input.padded {
  padding: 0.35rem;
  margin-left: 1rem;
  margin-bottom: 0.53rem;
}

input::-moz-placeholder,
input::-webkit-input-placeholder,
input::placeholder {
  color: rgba(34,36,38, .25);
}
</style>
